// TODO: image_url is null for all records - update with actual image URLs after image upload API is integrated
/**
 * Dummy data — 투어
 * API_DOCS: 9. 투어 (서비스) / 23. 관리자 - 투어
 *
 * TourResponse:
 *   id(int), name(string?), description(string?), address(string?), price(decimal?),
 *   duration_hours(int?), min_passengers(int), max_passengers(int),
 *   image_url(string?), is_active(boolean), sort_order(int), created_at(datetime)
 *
 * TourScheduleResponse:
 *   id(int), tour_id(int?), available_date(date?), pickup_time(time?),
 *   remaining_slots(int?), status(string), created_at(datetime)
 */

/* 기본 투어 일정 (itinerary) — API에서 tour별로 반환 */
const defaultItinerary = [
  { time: '09:00', icon: 'van', title: '호텔 픽업', desc: '숙소에서 전용 차량으로 출발', address: '서울 강남구 테헤란로 123' },
  { time: '10:00', icon: 'place', title: '북촌 한옥마을', desc: '전통 한옥마을 산책 및 포토타임', address: '서울 종로구 북촌로 일대' },
  { time: '11:30', icon: 'place', title: '경복궁', desc: '한복 체험 및 궁궐 관람', address: '서울 종로구 사직로 161' },
  { time: '13:00', icon: 'place', title: '점심 식사', desc: '현지 맛집에서 한식 코스 (비용 별도)', address: '서울 종로구 인사동길' },
  { time: '14:30', icon: 'place', title: '인사동 거리', desc: '전통 공예품 쇼핑 및 카페 투어', address: '서울 종로구 인사동길' },
  { time: '16:00', icon: 'place', title: '남산타워', desc: '서울 전경 감상 및 자유시간', address: '서울 용산구 남산공원길 105' },
  { time: '17:00', icon: 'van', title: '호텔 복귀', desc: '숙소까지 안전하게 이동', address: '서울 강남구 테헤란로 123' },
];

/* 투어 유의사항 (어드민에서 수정 가능) */
const defaultNotices = {
  vehicle: [
    '현대 스타리아 라운지 7인승 (2026년형)',
    '차량 내 생수, 충전 케이블, Wi-Fi 제공',
    '최대 탑승 인원: 6명',
  ],
  caution: [
    '투어 시작 시간은 예약 시 선택한 시간 기준이며, 지연 시 투어 시간이 단축될 수 있습니다.',
    '입장료, 식사비 등 개인 비용은 투어 요금에 포함되지 않습니다.',
    '기상 악화 시 일정이 변경될 수 있으며, 사전에 안내해 드립니다.',
  ],
  tour: [
    '투어 코스는 고객의 요청에 따라 변경 가능합니다.',
    '투어 중 개인 쇼핑 시간은 투어 시간에 포함됩니다.',
    '반려동물 동반 시 사전에 문의 바랍니다.',
  ],
  refund: [
    { period: '이용일 7일 전까지', ratio: '100% 환불' },
    { period: '이용일 3일 전까지', ratio: '50% 환불' },
    { period: '이용일 당일', ratio: '환불 불가' },
  ],
};

const tours = [
  {
    id: 1,
    name: '서울근교 자유여행 8시간',
    description: '서울 근교의 아름다운 명소를 프라이빗하게 즐기세요.',
    address: '서울특별시 중구',
    price: 350000,
    duration_hours: 8,
    min_passengers: 1,
    max_passengers: 6,
    image_url: null,
    itinerary: defaultItinerary,
    notices: defaultNotices,
    is_active: true,
    sort_order: 1,
    created_at: '2026-01-01T00:00:00',
  },
  {
    id: 2,
    name: '남이섬+춘천 당일투어',
    description: '남이섬과 춘천의 매력을 하루에 만끽하세요.',
    address: '강원도 춘천시',
    price: 420000,
    duration_hours: 10,
    min_passengers: 1,
    max_passengers: 6,
    image_url: null,
    is_active: true,
    sort_order: 2,
    created_at: '2026-01-10T00:00:00',
  },
  {
    id: 3,
    name: '제주도 프라이빗 투어 1일',
    description: '제주의 핵심 명소를 프라이빗하게.',
    address: '제주특별자치도',
    price: 500000,
    duration_hours: 10,
    min_passengers: 2,
    max_passengers: 6,
    image_url: null,
    is_active: true,
    sort_order: 3,
    created_at: '2026-01-15T00:00:00',
  },
  {
    id: 4,
    name: 'DMZ + 임진각 평화 투어',
    description: 'DMZ와 임진각을 방문하는 평화 역사 투어.',
    address: '경기도 파주시',
    price: 380000,
    duration_hours: 6,
    min_passengers: 2,
    max_passengers: 6,
    image_url: null,
    is_active: false,
    sort_order: 4,
    created_at: '2026-02-01T00:00:00',
  },
];

const tourSchedules = {
  1: [
    { id: 1, tour_id: 1, available_date: '2026-03-15', pickup_time: '09:00', remaining_slots: 4, status: 'available', created_at: '2026-02-01T00:00:00' },
    { id: 2, tour_id: 1, available_date: '2026-03-16', pickup_time: '09:00', remaining_slots: 6, status: 'available', created_at: '2026-02-01T00:00:00' },
    { id: 4, tour_id: 1, available_date: '2026-03-20', pickup_time: '09:00', remaining_slots: 0, status: 'fully_booked', created_at: '2026-02-01T00:00:00' },
  ],
  2: [
    { id: 3, tour_id: 2, available_date: '2026-03-17', pickup_time: '08:00', remaining_slots: 2, status: 'available', created_at: '2026-02-01T00:00:00' },
    { id: 5, tour_id: 2, available_date: '2026-03-10', pickup_time: '08:00', remaining_slots: 0, status: 'closed', created_at: '2026-02-01T00:00:00' },
  ],
};

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/* ── 서비스 (유저용) ── */

/** GET /api/tours */
export const getTours = async (params = {}) => {
  await delay(300);
  return tours.filter((t) => t.is_active);
};

/** GET /api/tours/:id */
export const getTourById = async (id) => {
  await delay(200);
  const found = tours.find((t) => t.id === Number(id));
  if (!found) throw new Error('투어를 찾을 수 없습니다');
  return found;
};

/** GET /api/tours/:id/schedules */
export const getTourSchedules = async (tourId) => {
  await delay(200);
  return tourSchedules[tourId] || [];
};

/** POST /api/tours/:tourId/reservations */
export const createTourReservation = async (tourId, data) => {
  await delay(200);
  const reservation = {
    id: Date.now(),
    reservation_number: `VVT-${Math.random().toString(36).slice(2, 14).toUpperCase()}`,
    service_type: 'tour',
    tour_id: Number(tourId),
    schedule_id: data?.schedule_id ?? null,
    passengers: data?.passengers ?? 1,
    booker_name: data?.booker_name ?? null,
    booker_phone: data?.booker_phone ?? null,
    booker_email: data?.booker_email ?? null,
    departure: data?.departure ?? null,
    departure_detail: data?.departure_detail ?? null,
    payment_method: data?.payment_method ?? null,
    status: 'pending',
    created_at: new Date().toISOString(),
  };
  return reservation;
};

/* ── 관리자 ── */

/** GET /api/admin/tours (페이지네이션) */
export const getAdminTours = async (params = {}) => {
  await delay(300);
  const page = params.page || 1;
  const size = params.size || 20;
  const start = (page - 1) * size;
  return {
    items: tours.slice(start, start + size),
    total: tours.length,
    page,
    size,
    pages: Math.ceil(tours.length / size),
  };
};

/** POST /api/admin/tours */
export const createTour = async (data) => {
  await delay(400);
  const newTour = {
    id: tours.length + 1,
    name: data.name || null,
    description: data.description || null,
    address: data.address || null,
    price: data.price || null,
    duration_hours: data.duration_hours || null,
    min_passengers: data.min_passengers || 1,
    max_passengers: data.max_passengers || 6,
    image_url: data.image_url || null,
    is_active: true,
    sort_order: tours.length + 1,
    created_at: new Date().toISOString(),
  };
  tours.push(newTour);
  return newTour;
};

/** PUT /api/admin/tours/:id */
export const updateTour = async (id, data) => {
  await delay(400);
  const idx = tours.findIndex((t) => t.id === Number(id));
  if (idx === -1) throw new Error('투어를 찾을 수 없습니다');
  tours[idx] = { ...tours[idx], ...data };
  return tours[idx];
};

/** DELETE /api/admin/tours/:id */
export const deleteTour = async (id) => {
  await delay(300);
  const idx = tours.findIndex((t) => t.id === Number(id));
  if (idx === -1) throw new Error('투어를 찾을 수 없습니다');
  tours.splice(idx, 1);
  return { message: '투어가 삭제되었습니다' };
};

/** GET /api/admin/tours/:tourId/schedules */
export const getAdminTourSchedules = async (tourId) => {
  await delay(200);
  return tourSchedules[tourId] || [];
};

/** POST /api/admin/tours/:tourId/schedules */
export const createTourSchedule = async (tourId, data) => {
  await delay(400);
  const schedule = { id: Date.now(), tour_id: Number(tourId), ...data, status: 'available', created_at: new Date().toISOString() };
  if (!tourSchedules[tourId]) tourSchedules[tourId] = [];
  tourSchedules[tourId].push(schedule);
  return schedule;
};

/** PUT /api/admin/tours/:tourId/schedules/:scheduleId */
export const updateTourSchedule = async (tourId, scheduleId, data) => {
  await delay(400);
  const list = tourSchedules[tourId] || [];
  const idx = list.findIndex((s) => s.id === Number(scheduleId));
  if (idx === -1) throw new Error('일정을 찾을 수 없습니다');
  list[idx] = { ...list[idx], ...data };
  return list[idx];
};

/** DELETE /api/admin/tours/:tourId/schedules/:scheduleId */
export const deleteTourSchedule = async (tourId, scheduleId) => {
  await delay(300);
  const list = tourSchedules[tourId] || [];
  const idx = list.findIndex((s) => s.id === Number(scheduleId));
  if (idx === -1) throw new Error('일정을 찾을 수 없습니다');
  list.splice(idx, 1);
  return { message: '일정이 삭제되었습니다' };
};
